import { CustomLoader } from "components/atoms";
import React from "react";

function FullScreenCustomLoader() {
  return (
    <div
      style={{
        bgcolor: "#000000BF",
        height: "100%",
        width: "100%",
        zIndex: "999999999",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CustomLoader />
    </div>
  );
}

export default FullScreenCustomLoader;
